export default class Colors {
  static swatch = [
    ['070', '191', '189'], // Teal
    ['253', '180', '092'], // Soft Orange
    ['151', '187', '205'], // Light Blue
    ['199', '096', '076'], // Soft Red
    ['125', '079', '109'], // Mauve
    ['157', '155', '127'], // Olive Green
    ['088', '074', '094'], // Purple Grey
    ['217', '112', '065'], // Burnt Orange
    ['243', '062', '111'], // Bright Pink
    ['224', '228', '204'], // Light Green
    ['105', '210', '231'], // Sky Blue
    ['243', '134', '048'], // Vivid Orange
    ['247', '070', '074'], // Salmon Pink
    ['077', '083', '096'], // Slate Grey
    ['226', '234', '233'], // Pale Cyan
    ['212', '204', '197'], // Warm Grey
    ['148', '159', '177'], // Cool Grey
    ['164', '196', '000'], // Lime Green
    ['255', '195', '000'], // Golden Yellow
    ['102', '153', '204'], // Dusty Blue
    ['204', '153', '102'], // Tan
    ['153', '204', '153'], // Soft Green
    ['204', '102', '153'], // Dusty Pink
    ['153', '102', '204'], // Lavender
    ['102', '204', '153'], // Sea Green
    ['204', '204', '153'], // Khaki
    ['153', '153', '204'], // Periwinkle
    ['102', '102', '153'], // Twilight
    ['153', '102', '102'], // Brick Red
    ['204', '153', '204'], // Orchid
    ['102', '153', '153'], // Teal Green
    ['204', '102', '102'], // Coral
    ['153', '153', '102'], // Olive Drab
    ['102', '204', '204'], // Turquoise
    ['204', '153', '153'], // Blush
    ['153', '204', '204'], // Powder Blue
    ['102', '102', '204'], // Indigo Light
    ['204', '204', '102'], // Mustard
  ];

  static getColor() {
    let i = 0;
    return function () {
      const value = Colors.swatch[i % Colors.swatch.length];
      i += 1;
      return `rgb(${value.join(',')})`;
    };
  }

  static getColorByIndex(index = 0) {
    const value = Colors.swatch[index % Colors.swatch.length];
    return `rgb(${value.join(',')})`;
  }
}
